import {Grid, Group, Page} from "@/comn/components";
import {useFetch, useGrid, usePage, useToast} from "@/comn/hooks";
import {useEffect} from "react";
import {APIS, PGEUIDS, SG_MENU_LIST} from "@/tra/tancis/ptli/ptl/roleauth/services/PtliRoleAuthService";

/*
 *  Menu List Popup
 * !== 메뉴 목록 팝업 ==!
 */
export const PTLI1016004Q = (props:any) => {
    const {pgeUid} = usePage({pgeUid: PGEUIDS.ptli1016004q});
    const toast  = useToast();

    const grid = { menuList: useGrid({ defaultSchema: SG_MENU_LIST }) }

    const fetch = {
        getMenuList: useFetch({
            api:  (data:any) => APIS.getMenuList(data),
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        })
    }

    useEffect(() => {
        grid.menuList.setOption("height", 200);
        fetch.getMenuList.fetch(props);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.menuList.grid}
                              data={fetch.getMenuList.data?.menuList}/>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    )
}